module.exports = __webpack_public_path__ + "img/c-thermometer-img8-3.4a6064d1.png";